<template>
  <action-person-template :action="action" column="person2" grid="person2" title="Buteur"/>
</template>

<script>
import ActionPersonTemplate from './ActionPersonTemplate'

export default {
  name: 'SportFootballMatchActionPersonAssistStriker',
  props: {
    action: Object
  },
  components: { ActionPersonTemplate }
}
</script>
